module.exports = __webpack_public_path__ + "img/e8.e482e92a.jpg";